import React, { memo } from "react";
import { LayersControl, TileLayer , GeoJSON} from "react-leaflet";
import "react-leaflet-fullscreen/dist";
import "react-leaflet-fullscreen/dist/styles.css";

const LayerControlMap = memo(({ layers , position = 'topright'}) => {
  
  // console.log("layers", layers);

  return (
    <LayersControl position={position}>
      <LayersControl.BaseLayer checked name="Google Satellite">
        <TileLayer
          url="http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
          minZoom="10"
          subdomains={['mt0','mt1','mt2','mt3']}
        />

      </LayersControl.BaseLayer>

      <LayersControl.BaseLayer name="Open Street Map">
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </LayersControl.BaseLayer>


      {layers &&
        layers.map(layer =>
          layer.layer.features.map((feature, index) => (

            <LayersControl.Overlay 
              checked
              name={`<div style='background-color:${layer.style.fillColor}' class='tiny-box'></div>${layer.name}`}
            >
              <GeoJSON
                key={`${layer.slug}-${index}`}
                data={feature.geometry}
                {...layer.style}
              />
            </LayersControl.Overlay>

          ))
        )
      }

    </LayersControl>
  );
});

export default LayerControlMap;
